var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"btn-outline-tertiary w-full",on:{"click":_vm.redirect}},[_vm._v(" Change the Application Signature Method ")])
}
var staticRenderFns = []

export { render, staticRenderFns }